import FacturarMasivoPage from "./GenerarFacturasMasivoPage";

export {FacturarMasivoPage}
export default FacturarMasivoPage
